export const constants = {
  videoSortBySelections: {
    recentUpload: {
      id: 1,
      enum: 'recentUpload',
      stringKey: 'ImageExperience_Sort_Recent_Upload',
      query: '$orderby=UploadedTime desc',
      edmDefinition: { UploadedTime: -1 },
    },
    description: {
      id: 2,
      enum: 'description',
      stringKey: 'ImageExperience_Sort_Video_Text',
      query: '$orderby=Text asc',
      edmDefinition: { Text: 1 },
    },
  },
};
